module.exports = __webpack_public_path__ + "static/24-c8219b4cef17624f3273fd6d4d1fa1a6.png";